<template>
    <div class="p-grid data-table data-table-list">
        <loading :active.sync="isLoading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
        <div class="p-col-12">
            <div class="card card-w-title">
                <DataTable :value="invoices" class="p-datatable-responsive" :paginator="true" :rows="10" :filters="filters" ref="admin_invoices">
                    <template #header>
                        <h2>List of invoices</h2>
                    </template>
                    <Column field="client_id" header="Client ID" :sortable="true">
                        <template #body="slotProps">
                            <span class="user_id">{{ slotProps.data.user_id }}</span>
                        </template>
                    </Column>
                    <Column field="client_name" header="Client Name" :sortable="true">
                        <template #body="slotProps">
                            <span class="user_id">{{ slotProps.data.user }}</span>
                        </template>
                    </Column>
                    <Column field="contract_id" header="Contract ID" :sortable="true">
                        <template #body="slotProps">
                            <span class="contract_id">{{ slotProps.data.purchase_id }}</span>
                        </template>
                    </Column>
                    <Column field="package_name" header="Package" :sortable="true">
                        <template #body="slotProps">
                            <span class="name">{{ slotProps.data.package_name }}</span>
                        </template>
                    </Column>
                    <Column field="payment_type" header="Payment type" :sortable="true">
                        <template #body="slotProps">
                            <span class="payment_type">{{ slotProps.data.payment_type }}</span>
                        </template>
                    </Column>
                    <Column field="amount" header="Amount" :sortable="true">
                        <template #body="slotProps">
                            <span class="price">€{{ formatCurrency(slotProps.data.amount) }}</span>
                        </template>
                    </Column>
                    <Column field="invoice_nr" header="Invoice No" :sortable="true">
                        <template #body="slotProps">
                            <span class="invoice_nr">{{ slotProps.data.invoice_nr }}</span>
                        </template>
                    </Column>
                    <Column field="time" header="Time of invoice" :sortable="true">
                        <template #body="slotProps">
                            <span class="time">{{ formatDate(slotProps.data.created_at) }}</span>
                        </template>
                    </Column>
                    <Column field="invoice" header="Invoice" :sortable="false">
                        <template #body="slotProps">
                            <a :href="apiUrl + 'invoices/' + slotProps.data.purchase_id + '.pdf'" target="_blank">
                                <Button label="PDF" class="btn-primary btn-open" icon="icon icon-open"/>
                            </a>
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>
    </div>
</template>

<script>

    import InvoiceService from '../../../service/InvoiceService';
      import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    data() {
        return {
            invoices: null,
            editingCellRows: {},
            editingRows: [],
            filters: {},
            activeRow: {},
            display: false,
            title: '',
            isLoading: false,
            message: 'Test message',
            apiUrl: process.env.VUE_APP_AUTH_URL,
            // columns: null
        }
    },
    created() {
        this.$store.commit('setPageTitle', {pageTitle: 'Invoices'});
        this.invoiceService = new InvoiceService();
        this.originalRows = {};
        },
    components: {
		Loading
	},
    async mounted() {
        await this.invoiceService.listInvoices().then(data => this.invoices = data);
        console.log(this.invoices);
        
    },
    methods: {
        formatDate(date) {
            var d = new Date(date),
                month = "" + (d.getMonth() + 1),
                day = "" + d.getDate(),
                year = d.getFullYear(),
                hours = "" + d.getHours(),
                mins = "" + d.getMinutes();

            if (month.length < 2) month = "0" + month;
            if (day.length < 2) day = "0" + day;
            if (hours.length < 2) hours = "0" + hours;
            if (mins.length < 2) mins = "0" + mins;

            return [year, month, day].join("-") + " " + hours + ":" + mins;
        },
        formatCurrency(value) {
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
    }
}

</script>

<style scoped>
</style>